import React from 'react';

import {
	styled,
	ParentBoundComponent,
	Module,
} from 'ps-gui';

import RecordingProtocolDetailModel from './recordingprotocoldetailmodel';


const Wrapper = styled.div`
	.ps-cross {
		.ps-tabularInput {
			flex-grow: 1;
		}
	}
`;

export default class RecordingProtocolDetailModule extends ParentBoundComponent {
	constructor() {
		super();
	}



	getModel() {
		return new RecordingProtocolDetailModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		if (!this.getData().get('initialized')) {
			this.setModel(this.getModel().initialize());
		}
	}


	render() {
		const data = this.getData();
		return (
			<Wrapper>
				<Module
					appState={data.get('wizard')}
					onDataChange={newData => {
						this.setData(data.setIn(['wizard', 'data'], newData));
					}}
				/>
			</Wrapper>
		);
	}
}


